import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=b0c7e6ee&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=js&"
export * from "./Videos.vue?vue&type=script&lang=js&"
import style0 from "./Videos.vue?vue&type=style&index=0&id=b0c7e6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c7e6ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiModalVideo: require('/var/www/homolog.intelli.com.br/intelli.owinteractive.com/components/base/ui/ModalVideo.vue').default})
